import apiClient from './apiClient';

export const mapBrokerFromApi = (b) => {
  if (!b) return null;
  const id = b._id?.toString?.() ?? b.id;
  return {
    id,
    _id: b._id,
    name: b.name,
    slug: b.slug,
    logo: b.logo || '📊',
    color: b.color || 'from-primary-400 to-primary-600',
    rating: b.rating ?? 4.5,
    activeClients: b.activeClients || '50L+',
    activeClientsTrend: b.activeClientsTrend || 'Growing',
    brokerage: b.brokerage || '0.05%',
    description: b.description || 'Leading stock broker in India.',
    features: Array.isArray(b.features) ? b.features : [],
    charges: b.charges || { delivery: '0%', intraday: '0.05%', futures: '0.05%' },
    complaints: b.complaints || { total: 100, resolved: 92 },
    shareHolding: b.shareHolding || { promoters: '50%', public: '50%' },
    pros: Array.isArray(b.pros) ? b.pros : [],
    cons: Array.isArray(b.cons) ? b.cons : [],
    financials: b.financials || { revenue: '₹1,000 Cr', profit: '₹200 Cr', marketCap: '₹5,000 Cr' },
    createdAt: b.createdAt,
    updatedAt: b.updatedAt,
  };
};

export const getBrokers = async () => {
  const { data } = await apiClient.get('/api/brokers');
  return Array.isArray(data) ? data.map(mapBrokerFromApi) : [];
};

/** Raw list (no mapping) – for Compare page to show "-" for missing fields. */
export const getBrokersRaw = async () => {
  const { data } = await apiClient.get('/api/brokers');
  return Array.isArray(data) ? data : [];
};

export const getBrokerById = async (id) => {
  const { data } = await apiClient.get(`/api/brokers/${id}`);
  return mapBrokerFromApi(data);
};

export const getBrokerByName = async (name) => {
  const { data } = await apiClient.get(`/api/brokers/by-name/${encodeURIComponent(name)}`);
  return mapBrokerFromApi(data);
};

export const getBrokerBySlug = async (slug) => {
  const { data } = await apiClient.get(`/api/brokers/by-slug/${encodeURIComponent(slug)}`);
  return mapBrokerFromApi(data);
};

/**
 * Raw endpoints (no mapping/defaults) – useful when UI wants to show '-' for missing fields.
 */
export const getBrokerByNameRaw = async (name) => {
  const { data } = await apiClient.get(`/api/brokers/by-name/${encodeURIComponent(name)}`);
  return data;
};

export const getBrokerBySlugRaw = async (slug) => {
  const { data } = await apiClient.get(`/api/brokers/by-slug/${encodeURIComponent(slug)}`);
  return data;
};

export const createBroker = async (payload) => {
  const { data } = await apiClient.post('/api/brokers', payload);
  return mapBrokerFromApi(data);
};

export const updateBroker = async (id, payload) => {
  const { data } = await apiClient.put(`/api/brokers/${id}`, payload);
  return mapBrokerFromApi(data);
};

export const deleteBroker = async (id) => {
  await apiClient.delete(`/api/brokers/${id}`);
};

